import PropTypes from 'prop-types';

const propTypes = PropTypes.arrayOf(PropTypes.shape({
  type: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  diff: PropTypes.number.isRequired,
  pct: PropTypes.number.isRequired,
}));

export default propTypes;
